import * as z from "zod/v4";

export const checkSession = {
  name: "checkSession" as const,
  input: z.object({}),
  output: z.object({ version: z.number().nullable() }),
};
